export const ChartType = Object.freeze({
  x: 'x',
  line: 'line',
});

export const BaseAnimationDuration = 300;
